// client/src/pages/dashboard-v2/components/SoldInfo.js
import React, { useState, useEffect } from 'react';
import Axios from 'axios';

export default function SoldInfo() {
  const [d, setD] = useState({
    profit: 0, cost: 0, soldPrice: 0, soldCount: 0,
    soldFeeGrade: 0, soldFeeShip: 0, soldFee: 0, soldFeeAds: 0
  });

  useEffect(() => {
    (async () => {
      try {
        const [p,c,sp,sc,g,sh,f,a] = await Promise.all([
          Axios.get('https://api.alientrader.cards/sold/profit'),
          Axios.get('https://api.alientrader.cards/sold/cost'),
          Axios.get('https://api.alientrader.cards/sold/price'),
          Axios.get('https://api.alientrader.cards/sold/count'),
          Axios.get('https://api.alientrader.cards/sold/card_fee_grade'),
          Axios.get('https://api.alientrader.cards/sold/card_solds_ship'),
          Axios.get('https://api.alientrader.cards/sold/card_sold_fees'),
          Axios.get('https://api.alientrader.cards/sold/card_sold_fees_ads'),
        ]);
        setD({
          profit: p.data[0].TotalProfit,
          cost: c.data[0].TotalCost,
          soldPrice: sp.data[0].TotalSoldPrice,
          soldCount: sc.data[0].TotalSoldCount,
          soldFeeGrade: g.data[0].SoldFeeGrade,
          soldFeeShip: sh.data[0].SoldFeeShip,
          soldFee: f.data[0].SoldFee,
          soldFeeAds: a.data[0].SoldFeeAds,
        });
      } catch (e) { console.error(e); }
    })();
  }, []);

  const net = d.soldPrice - d.soldFee - d.soldFeeShip - d.soldFeeAds;

  // minimal markup; the frame supplies layout/skin
  return (
<div className="info-grid">
  <span className="k">Cards Sold:</span><span className="v">{d.soldCount}</span>
  <span className="k">Profit:</span><span className="v">{fmt(d.profit)}</span>
  <span className="k">Total Sales:</span><span className="v">{fmt(d.soldPrice)}</span>
  <span className="k">Total Cost:</span><span className="v">{fmt(d.cost)}</span>
  <span className="k">Grading Cost:</span><span className="v">{fmt(d.soldFeeGrade)}</span>
  <span className="k">Shipping Fees:</span><span className="v">{fmt(d.soldFeeShip)}</span>
  <span className="k">Selling Fees:</span><span className="v">{fmt(d.soldFee)}</span>
  <span className="k">Ad Fees:</span><span className="v">{fmt(d.soldFeeAds)}</span>
  <span className="k">Sales − Fees:</span><span className="v total">{fmt(net)}</span>
</div>

  );
}

function fmt(n){ return n.toLocaleString('en-US',{style:'currency',currency:'USD'}); }
